import React from "react";

import { Project, Tech } from "./types";
import {
   Bash,
   Bootstrap,
   Css,
   Express,
   HTML,
   Javascript,
   Node,
   Next,
   Sass,
   ReactJS,
   Typescript,
   Git,
   MongoDB,
   Redux,
   MySQL,
   Neovim,
   Vsc,
   Postman,
   Linux,
   Java,
   SpringBoot,
   Python,
   Django,
} from "./assets/techs/logo-component";

const AdminPanel = React.lazy(() => import("./assets/projects/AdminPanel"));
const ApiBooking = React.lazy(() => import("./assets/projects/ApiBooking"));
const ApiShop = React.lazy(() => import("./assets/projects/ApiShop"));
const ApiYoutubeClone = React.lazy(() => import("./assets/projects/ApiYoutubeClone"));
const ApiUserManager = React.lazy(() => import("./assets/projects/ApiUserManager"));
const Blackjack = React.lazy(() => import("./assets/projects/Blackjack"));
const BookStore = React.lazy(() => import("./assets/projects/BookStore"));
const Booking = React.lazy(() => import("./assets/projects/Booking"));
const BoostrapIntro = React.lazy(() => import("./assets/projects/BoostrapIntro"));
const CarouselSendForm = React.lazy(() => import("./assets/projects/CarouselSendForm"));
const CollectionBooks = React.lazy(() => import("./assets/projects/CollectionBooks"));
const SideBar = React.lazy(() => import("./assets/projects/SideBar"));
const EmojiInput = React.lazy(() => import("./assets/projects/EmojiInput"));
const TodoMvc = React.lazy(() => import("./assets/projects/TodoMvc"));
const YoutubeClone = React.lazy(() => import("./assets/projects/YoutubeClone"));

export const dataProjects: Project[] = [
   {
      id: 1,
      Img: YoutubeClone,
      description: "Youtube Clone",
      url: "https://jos-tube28.netlify.app/",
   },
   {
      id: 2,
      Img: Booking,
      description: "Booking App",
      url: "https://jo-booking-app.netlify.app/",
   },
   {
      id: 3,
      Img: AdminPanel,
      description: "Admin Panel",
      url: "https://joadminpanel.netlify.app/",
   },
   {
      id: 4,
      Img: Blackjack,
      description: "Blackjack",
      url: "https://josuemedinaguerrero.github.io/blackjack/",
   },
   {
      id: 5,
      Img: BoostrapIntro,
      description: "Responsive Bootstrap Proyect",
      url: "https://josuemedinaguerrero.github.io/bootstrap-book/",
   },
   {
      id: 6,
      Img: CarouselSendForm,
      description: "Image Carousel and Functional Form",
      url: "https://jos-carousel-and-sendform.netlify.app/",
   },
   {
      id: 7,
      Img: BookStore,
      description: "Collection Books",
      url: "https://josuemedinaguerrero-bookstore.netlify.app/",
   },
   {
      id: 8,
      Img: CollectionBooks,
      description: "Book Collection",
      url: "https://josuemedinaguerrero.github.io/book-collection/",
   },
   {
      id: 9,
      Img: TodoMvc,
      description: "Todo MVC",
      url: "https://josuemedinaguerrero.github.io/todo-mvc/",
   },
   {
      id: 10,
      Img: SideBar,
      description: "Sidebar",
      url: "https://jo-sidebar.netlify.app/",
   },
   {
      id: 11,
      Img: EmojiInput,
      description: "Emoji Input",
      url: "https://jo-emoji.netlify.app/",
   },
   {
      id: 12,
      Img: ApiYoutubeClone,
      description: "API - Youtube Clone",
      url: "https://documenter.getpostman.com/view/20128768/UzXKWymw",
   },
   {
      id: 13,
      Img: ApiBooking,
      description: "API - Booking App",
      url: "https://documenter.getpostman.com/view/20128768/UzBnsSmR",
   },
   {
      id: 14,
      Img: ApiShop,
      description: "API - Shop",
      url: "https://documenter.getpostman.com/view/20128768/UyxbqUz2",
   },
   {
      id: 15,
      Img: ApiUserManager,
      description: "Api - User Manager",
      url: "https://documenter.getpostman.com/view/20128768/UzBns7pU",
   },
];

export const knowledges: Tech[] = [
   {
      id: 1,
      icon: HTML,
      desc: "HTML5",
   },
   {
      id: 2,
      icon: Css,
      desc: "CSS3",
   },
   {
      id: 3,
      icon: Javascript,
      desc: "Javascript",
   },
   {
      id: 4,
      icon: Typescript,
      desc: "Typescript",
   },
   {
      id: 5,
      icon: Java,
      desc: "Java",
   },
   {
      id: 6,
      icon: Python,
      desc: "Python",
   },
   {
      id: 7,
      icon: ReactJS,
      desc: "React",
   },
   {
      id: 8,
      icon: Redux,
      desc: "Redux",
   },
   {
      id: 9,
      icon: Node,
      desc: "NodeJS",
   },
   {
      id: 10,
      icon: Express,
      desc: "Express",
   },
   {
      id: 11,
      icon: SpringBoot,
      desc: "Spring Boot - Spring Security",
   },
   {
      id: 12,
      icon: Django,
      desc: "Django",
   },
   {
      id: 12,
      icon: Next,
      desc: "NextJS",
   },
   {
      id: 13,
      icon: MongoDB,
      desc: "MongoDB",
   },
   {
      id: 14,
      icon: MySQL,
      desc: "MySQL",
   },
   {
      id: 15,
      icon: Bootstrap,
      desc: "Bootstrap 5",
   },
   {
      id: 16,
      icon: Sass,
      desc: "Sass",
   },
   {
      id: 17,
      icon: Git,
      desc: "Git",
   },
   {
      id: 18,
      icon: Vsc,
      desc: "Visual Studio Code",
   },
   {
      id: 19,
      icon: Bash,
      desc: "Bash",
   },
   {
      id: 21,
      icon: Postman,
      desc: "Postman",
   },
   {
      id: 22,
      icon: Linux,
      desc: "Linux",
   },
];
